<template>
  <div class="container page-not-found">
    <div class="row">
      <div class="col-6 col-mlg-5 col-xl-4 mx-auto d-flex flex-column align-items-center">
        <svg width="132" height="132" viewBox="0 0 132 132" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M51 68.4529H64.1564V73.4837H68.9234V68.4529H72.4515V64.4151H68.9234V46.3707H62.7021L51 64.5475V68.4529ZM64.2103 64.4151H56.1171V64.2033L63.9948 51.931H64.2103V64.4151Z" fill="#3C67FF" />
          <path d="M86.9478 74C93.6001 74.0132 97.5726 68.8501 97.5726 59.9537C97.5726 51.1102 93.5732 46 86.9478 46C80.3225 46 76.3365 51.0969 76.323 59.9537C76.323 68.8369 80.2956 74 86.9478 74ZM86.9478 69.8562C83.514 69.8562 81.3594 66.4671 81.3728 59.9537C81.3863 53.4931 83.5274 50.0908 86.9478 50.0908C90.3817 50.0908 92.5228 53.4931 92.5363 59.9537C92.5363 66.4671 90.3951 69.8562 86.9478 69.8562Z" fill="#3C67FF" />
          <path d="M101.548 68.4529H114.705V73.4837H119.472V68.4529H123V64.4151H119.472V46.3707H113.251L101.548 64.5475V68.4529ZM114.759 64.4151H106.666V64.2033L114.543 51.931H114.759V64.4151Z" fill="#3C67FF" />
          <circle opacity="0.5" cx="52.5" cy="67.5" r="34.5" fill="#7190FF" />
          <path opacity="0.5" d="M78.1856 78.1856C91.6586 64.7125 91.6586 42.8683 78.1856 29.3952C64.7125 15.9221 42.8683 15.9221 29.3952 29.3952C15.9221 42.8683 15.9221 64.7125 29.3952 78.1856C42.8683 91.6587 64.7125 91.6587 78.1856 78.1856ZM78.1856 78.1856L105.409 105.409" stroke="#0A3BE7" stroke-width="6" />
        </svg>
        <h1 class="typo-heading24 typo-semibold text-light-high text-center mt-half">{{ $t("error.page404") }}</h1>
      </div>
    </div>
    <div class="actions row mt-5">
      <div class="col-3 pr-half ml-auto">
        <button class="btn btn-outline btn-outline-dark3 btn-block btn-default" :data-tooltips="$t('generals.inBeta')" data-position="top" @click="$chatbox.show">
          <svg class="mr-half" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="5" cy="5" r="5" fill="#3C67FF" />
          </svg>
          {{ $t("generals.liveC") }}
        </button>
      </div>
      <div class="col-3 pl-half mr-auto">
        <router-link :to="{ name: 'Dashboard' }" class="btn btn-primary btn-block btn-default">{{ $t("thanks.back") }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageNotFound"
};
</script>

<style lang="scss" scoped>
.page-not-found {
  padding-top: calc(29vh - 80px);
}
</style>
